import { useEffect, useState } from "react";
// ui
import {
  Box,
  Alert,
  Paper,
  Select,
  FormControl,
  MenuItem,
  TextField,
} from "@mui/material";
import { styled } from "@mui/system";

import { LIST_POST } from "../../config/const";

// ★cmd-po_1139: PoModalShell + PoButton で catalog 外殻を導入
// 独自 style width 500px / maxHeight 70vh → Shell 経由で catalog 560px / 92vh に統一
import { PoModalShell } from "../common/PoModalShell";
import { PoButton } from "../common/PoButton";

const CustomTextField = styled(TextField)({
  "& .MuiInputBase-input": {
    fontSize: "12px",
    height: "12px", // ここでフォントサイズを指定
  },
});
CustomTextField.defaultProps = {
  autoComplete: "off",
};

interface FollowCallConfigCopyModalProps {
  onModal: boolean;
  swCloseModal: () => void;
  copyDataInf: {
    status: null | "loading" | "open" | "success" | "failed";
    key: { [key: string]: string };
    message: string;
    follow_call_entry_status_conf: number | null;
    follow_call_entry_status: string;
    follow_call_base_day_conf: number | null;
    follow_call_day_offset: number | null;
  };
  setCopyDataInf: (value: {
    status: null | "loading" | "open" | "success" | "failed";
    key: { [key: string]: string };
    message: string;
    follow_call_entry_status_conf: number | null;
    follow_call_entry_status: string;
    follow_call_base_day_conf: number | null;
    follow_call_day_offset: number | null;
  }) => void;
  copyData: () => void;
}

export function FollowCallConfigCopyModal(
  props: FollowCallConfigCopyModalProps
) {
  const { onModal, swCloseModal, copyDataInf, setCopyDataInf, copyData } =
    props;

  const [disabledBottun, setDisabledBottun] = useState(true);
  useEffect(() => {
    let disabledBottun = false;
    if (copyDataInf.follow_call_entry_status_conf === null) {
      disabledBottun = true;
    }
    if (
      copyDataInf.follow_call_entry_status_conf === 1 &&
      copyDataInf.follow_call_entry_status === ""
    ) {
      disabledBottun = true;
    }
    if (copyDataInf.follow_call_base_day_conf === null) {
      disabledBottun = true;
    }
    if (copyDataInf.follow_call_day_offset === null) {
      disabledBottun = true;
    }
    setDisabledBottun(disabledBottun);
  }, [copyDataInf]);

  // footer: sec（戻る/キャンセル系）→ pri（submit）の catalog 順
  const footer =
    copyDataInf.status === "open" ? (
      <>
        <PoButton
          variant="secondary"
          onClick={swCloseModal}
        >
          戻る
        </PoButton>
        <PoButton
          variant="primary"
          disabled={disabledBottun}
          data-testid="follow-call-config-copy-submit"
          onClick={copyData}
        >
          コピー
        </PoButton>
      </>
    ) : copyDataInf.status === "success" ? (
      <PoButton
        variant="secondary"
        data-testid="follow-call-config-copy-success-close"
        onClick={swCloseModal}
      >
        閉じる
      </PoButton>
    ) : copyDataInf.status === "failed" ? (
      <PoButton
        variant="secondary"
        data-testid="follow-call-config-copy-failed-back"
        onClick={() =>
          setCopyDataInf({
            ...copyDataInf,
            status: "open",
            message: "",
          })
        }
      >
        戻る
      </PoButton>
    ) : null;

  return (
    <PoModalShell
      open={onModal}
      title="フォローコール設定のコピー"
      onClose={swCloseModal}
      testidPrefix="follow-call-config-copy"
      footer={footer}
    >
      {copyDataInf.status === "open" ? (
        <Paper elevation={0}>
          <Box component="label" className="po-label">エントリーステータスの指定</Box>
          <Box key="servicePlanBox">
            <FormControl
              fullWidth
              sx={{
                marginTop: "10px",
                marginBottom: "20px",
                marginLeft: "5px",
                width: "calc(100% - 10px)",
              }}
            >
              <Select
                labelId="serch-input-label"
                id="serch-input-option"
                key={"servicePlanSelect"}
                data-testid="follow-call-config-copy-status-select"
                value={copyDataInf.follow_call_entry_status_conf}
                onChange={(e) => {
                  const follow_call_entry_status_conf = e.target
                    .value as number;
                  setCopyDataInf({
                    ...copyDataInf,
                    follow_call_entry_status_conf,
                    follow_call_entry_status: "",
                  });
                }}
                sx={{
                  height: "30px",
                  textAlign: "end",
                  fontSize: "14px",
                }}
              >
                {LIST_POST.follow_call_entry_status_conf.map(
                  (follow_call, i) => {
                    return (
                      <MenuItem
                        key={"follow_call_entry_status_conf" + i}
                        value={follow_call.id}
                        sx={{
                          fontSize: "14px",
                          height:
                            follow_call.value === "" ? "14px" : "24px",
                          minHeight: "auto",
                        }}
                      >
                        {follow_call.value}
                      </MenuItem>
                    );
                  }
                )}
              </Select>
            </FormControl>
          </Box>
          <Box component="label" className="po-label">エントリーステータス</Box>
          <Box key="hope_call_time">
            <CustomTextField
              disabled={copyDataInf.follow_call_entry_status_conf === 0}
              id="hope_call_time"
              size="small"
              value={copyDataInf.follow_call_entry_status}
              onChange={async (e) => {
                setCopyDataInf({
                  ...copyDataInf,
                  follow_call_entry_status: e.target.value,
                });
              }}
              sx={{
                width: "calc(100% - 10px)",
                margin: "10px 5px",
              }}
            />
          </Box>
          <Box component="label" className="po-label">基準日</Box>
          <Box key="servicePlanBox2">
            <FormControl
              fullWidth
              sx={{
                marginTop: "10px",
                marginBottom: "20px",
                marginLeft: "5px",
                width: "calc(100% - 10px)",
              }}
            >
              <Select
                labelId="serch-input-label"
                id="serch-input-option"
                key={"servicePlanSelect"}
                data-testid="follow-call-config-copy-baseday-select"
                value={copyDataInf.follow_call_base_day_conf}
                onChange={(e) => {
                  const follow_call_base_day_conf = e.target
                    .value as number;
                  let follow_call_day_offset =
                    copyDataInf.follow_call_day_offset;
                  if (
                    (follow_call_day_offset ||
                      follow_call_day_offset === 0) &&
                    (follow_call_base_day_conf === 0 ||
                      follow_call_base_day_conf === 1) &&
                    follow_call_day_offset < 1
                  ) {
                    follow_call_day_offset = null;
                  }
                  setCopyDataInf({
                    ...copyDataInf,
                    follow_call_base_day_conf,
                    follow_call_day_offset,
                  });
                }}
                sx={{
                  height: "30px",
                  textAlign: "end",
                  fontSize: "14px",
                }}
              >
                {LIST_POST.follow_call_base_day_conf.map(
                  (follow_call, i) => {
                    return (
                      <MenuItem
                        key={"follow_call_base_day_conf" + i}
                        value={follow_call.id}
                        sx={{
                          fontSize: "14px",
                          height:
                            follow_call.value === "" ? "14px" : "24px",
                          minHeight: "auto",
                        }}
                      >
                        {follow_call.value}
                      </MenuItem>
                    );
                  }
                )}
              </Select>
            </FormControl>
          </Box>
          <Box component="label" className="po-label">日時設定</Box>
          <Box key="servicePlanBox3">
            <FormControl
              fullWidth
              sx={{
                marginTop: "10px",
                marginBottom: "20px",
                marginLeft: "5px",
                width: "calc(100% - 10px)",
              }}
            >
              <Select
                labelId="serch-input-label"
                id="serch-input-option"
                key={"servicePlanSelect"}
                data-testid="follow-call-config-copy-offset-input"
                value={copyDataInf.follow_call_day_offset}
                onChange={(e) => {
                  const follow_call_day_offset = e.target.value as number;
                  setCopyDataInf({
                    ...copyDataInf,
                    follow_call_day_offset,
                  });
                }}
                sx={{
                  height: "30px",
                  textAlign: "end",
                  fontSize: "14px",
                }}
              >
                {copyDataInf.follow_call_base_day_conf === 2
                  ? LIST_POST.follow_call_day_offset_open.map(
                      (follow_call, i) => {
                        return (
                          <MenuItem
                            key={"follow_call_day_offset" + i}
                            value={follow_call.id}
                            sx={{
                              fontSize: "14px",
                              height:
                                follow_call.value === ""
                                  ? "14px"
                                  : "24px",
                              minHeight: "auto",
                            }}
                          >
                            {follow_call.value}
                          </MenuItem>
                        );
                      }
                    )
                  : LIST_POST.follow_call_day_offset.map(
                      (follow_call, i) => {
                        return (
                          <MenuItem
                            key={"follow_call_day_offset" + i}
                            value={follow_call.id}
                            sx={{
                              fontSize: "14px",
                              height:
                                follow_call.value === ""
                                  ? "14px"
                                  : "24px",
                              minHeight: "auto",
                            }}
                          >
                            {follow_call.value}
                          </MenuItem>
                        );
                      }
                    )}
              </Select>
            </FormControl>
          </Box>
        </Paper>
      ) : copyDataInf.status === "success" ? (
        <Box>成功しました。</Box>
      ) : copyDataInf.status === "failed" ? (
        <Box>{copyDataInf.message}</Box>
      ) : null}
    </PoModalShell>
  );
}
